import { render } from "./App.vue?vue&type=template&id=72e5294e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=72e5294e&lang=css"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__